// src/hooks/useCrearResultado.js

import { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";

import { parseExcel, validateExcelRows, transformFormDataToPayload,
  transformExcelRowsToPayload, } from "../utils/resultUtils";

import { apiSaveResultado, } from "../api/resultApi";
import { apiGetConsecutivos } from "../api/rutasApi";

export const useCrearResultado = () => {
  const [formData, setFormData] = useState({
    Factura: "",
    Tipo_id: "",
    Identificacion: "",
    fullname: "",
    APIM: "",
    Tipo_APIM: "",
    Fuente_APIM: "",
    Fecha_APIM: "",
    Data_APIM1: "",
    Data_APIM2: "",
    Data_APIM3: "",
    Cantidad_APIM: "",
    Cod_Diagnostico: "",
    ID_Prestador: "",
    Tipo_ID_prestador: "",
    Unic_id_APIM: "",
    consecutivo: "",
  });

  const [formVisible, setFormVisible] = useState(true);
  const [excelData, setExcelData] = useState([]);
  const [validationResults, setValidationResults] = useState({});
  const [editRowIndex, setEditRowIndex] = useState(null);
  const [excelLoaded, setExcelLoaded] = useState(false);
  const inputRefs = useRef({});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pacienteSeleccionado, setPacienteSeleccionado] = useState(null);

  const [consecutivos, setConsecutivos] = useState([]);

  // cargar consecutivos
  useEffect(() => {
    const load = async () => {
      try {
        const res = await apiGetConsecutivos();
        const data = await res.json();
        setConsecutivos(data.GetConsecutivos);
      } catch (err) {
        console.error("Error obteniendo consecutivos:", err);
      }
    };
    load();
  }, []);

  // ---------------- MODAL ----------------
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleSelectPaciente = (p) => {
    setPacienteSeleccionado(p);
    setFormData((prev) => ({
      ...prev,
      Tipo_id: p?.tipo || "",
      Identificacion: p?.id || "",
      fullname: p?.name || "",
    }));
    handleCloseModal();
  };

  // ---------------- FORM CHANGE ----------------
  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (type === "date") {
      return setFormData((prev) => ({
        ...prev,
        [name]: value ? new Date(value).toISOString().split("T")[0] : "",
      }));
    }

    if (name === "consecutivo") {
      return setFormData((prev) => ({ ...prev, consecutivo: Number(value) }));
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ---------------- EXCEL ----------------
  const handleExcelUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    parseExcel(file, (data) => {
      setExcelData(data);
      setExcelLoaded(true);
      setFormVisible(false);
    });
  };

  const handleValidate = () => {
    const results = validateExcelRows(excelData);
    setValidationResults(results);
    return Object.values(results).some((r) => !r.valid);
  };

  const handleCellChange = (e, rowIndex, col) => {
    const { value, type } = e.target;

    setExcelData((prev) =>
      prev.map((row, idx) => {
        if (idx !== rowIndex) return row;

        if (type === "date") {
          return {
            ...row,
            [col]: value ? new Date(value).toISOString().split("T")[0] : "",
          };
        }

        if (col === "consecutivo") {
          return { ...row, [col]: Number(value) };
        }

        return { ...row, [col]: value };
      })
    );
  };

  // ---------------- SAVE ----------------
  const handleSaveData = async () => {
    try {
      const payload = [transformFormDataToPayload(formData)];
      const res = await apiSaveResultado(payload);
      const result = await res.json();

      if (!res.ok || !result.success) throw new Error(result.message);

      toast.success("Resultado Guardado Correctamente.");

    } catch (err) {
      toast.error("Error al guardar resultado");
    }
  };

  const handleSaveExcelData = async () => {
    if (handleValidate()) {
      toast.error("Existen registros con errores (Validar)");
      return;
    }

    try {
      const payload = transformExcelRowsToPayload(excelData);
      const res = await apiSaveResultado(payload);
      const result = await res.json();

      if (!res.ok || !result.success) throw new Error(result.message);

      toast.success("Todos los resultados guardados con éxito.");
    } catch (err) {
      toast.error("Error al guardar resultado");
    }
  };

  return {
    formData,
    formVisible,
    excelData,
    validationResults,
    editRowIndex,
    excelLoaded,
    inputRefs,
    pacienteSeleccionado,
    isModalOpen,
    consecutivos,

    handleOpenModal,
    handleCloseModal,
    handleSelectPaciente,

    handleChange,
    handleExcelUpload,
    handleCellChange,

    handleValidate,
    handleSaveData,
    handleSaveExcelData,
  };
};
